import { Msg, MsgService } from "../../msg";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MsgRecipient } from "@app/_components/msg-recipient/msg-recipient";
import { OwnerLeadProfileService } from "../owner-lead-profile.service";
import { OwnerPropertyDetails } from "./owner-property-details";
import { PropertyLeadProfileService } from "@app/_components/property-lead-profile/property-lead-profile.service";
import { OwnerPropertyDetailsService } from "../owner-property-details.service";

@Component({
    selector: "app-owner-property-details",
    templateUrl: "./owner-property-details.component.html",
    styleUrls: ["./owner-property-details.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerPropertyComponent implements OnInit {

  countries: any;
  constructor(
    private primengConfig: PrimeNGConfig,
    private ownerLeadProfileService: OwnerLeadProfileService,
    private ownerPropertyDetailsService: OwnerPropertyDetailsService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private constantService: ConstantService,
    private propertyLeadProfileService: PropertyLeadProfileService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title;
    this.ownerPropertyDetails = data.ownerLeadProfile;
    this.ownerLeadProfileId = data.ownerLeadProfileId;
    this.assignedPropertyLeadIds = data.assignedPropertyLeadIds;
    this.isEditForm = data.isEditForm;
    this.statuses = ownerPropertyDetailsService.ownerPropertystatuses;
    this.countries = this.constantService.countries;
  }

  @Input() ownerPropertyDetails: OwnerPropertyDetails;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();


  // data
  ownerPropertyDetailId: Number;
  selectedMsgRecipients: any[] = [];
  ownerLeadProfileId:any;
  assignedPropertyLeadIds:any[] = [];
  isEditForm: boolean = false;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;
  propertyLeadProperties: any[]=[];
  selectedPropertyLeadProfile: any;
  disabledPropertySelection: boolean = false;

  validationMessages = {
    opsNotes: [{ type: 'required', message: 'Operation note is required.' }],
    status: [{ type: 'required', message: 'Status is required' }],
    propertyLeadProfileId: [{ type: 'required', message: 'Property Lead Profile is required' }],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();
    this.fetchPropertLeadProfile();

    if (this.ownerPropertyDetails) { // Edit property lead
      this.fixDates();
      this.form1.patchValue({
				status : this.ownerPropertyDetails.status,
				opsNotes : this.ownerPropertyDetails.opsNotes,
				propertyLeadProfileId : this.ownerPropertyDetails.propertyLeadProfileId,
				ownerLeadProfileId : this.ownerPropertyDetails.ownerLeadProfileId // Show default property selected from Mls record to select same property from property lead profile
			});
      // this.form1.patchValue(this.ownerPropertyDetails);
      this.ownerPropertyDetailId = this.ownerPropertyDetails.ownerLeadProfileId
    } else if(this.ownerLeadProfileId) { // Add property lead
      this.ownerPropertyDetailId = this.ownerLeadProfileId;
      this.form1.patchValue({ ownerLeadProfileId: this.ownerLeadProfileId });
    }

    //Disable property selection if opened in edit dialog to avoid duplicate or new record creation issue in relation/join table
    if(this.isEditForm) {
      this.disabledPropertySelection = true;
    }
  }

  //PropertyLead Profile

	fetchPropertLeadProfile() {
		try {
			this.propertyLeadProfileService.findAll().subscribe(
				(res) => {
          let propertyList = res.data.propertyLeadProfiles;
          //start with empty list
					this.propertyLeadProperties = [];
					if (propertyList.length > 0) {
						propertyList.forEach(propertyLeadPropery => {
							if (propertyLeadPropery.propertyLeadProfileId == this.ownerPropertyDetails?.propertyLeadProfileId) {
								this.selectedPropertyLeadProfile = propertyLeadPropery;
							}
							//set custom option label
							propertyLeadPropery = this.setPropertyLeadDisplayLabel(propertyLeadPropery);

              //Exclude already assigned property from list while adding
              //Exclude already assigned property but include current editing record propety while editing existing property
              if(!this.assignedPropertyLeadIds.includes(propertyLeadPropery.propertyLeadProfileId)
              || propertyLeadPropery.propertyLeadProfileId == this.ownerPropertyDetails?.propertyLeadProfileId) {
                this.propertyLeadProperties.push(propertyLeadPropery);
              }
						});
					}
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { }
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  setPropertyLeadDisplayLabel(propertyLeadPropery) {
		propertyLeadPropery.displayLabel = "";
		if (propertyLeadPropery.subjAdrDevelopmentName != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + propertyLeadPropery.subjAdrDevelopmentName;
		}
		if (propertyLeadPropery.subjAdrStreet != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrStreet;
		}
		if (propertyLeadPropery.subjAdrUnit != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrUnit;
		}
		if (propertyLeadPropery.subjAdrCity != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrCity;
		}
		if (propertyLeadPropery.subjAdrState != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrState;
		}
		if (propertyLeadPropery.subjAdrPostalCode != null) {
			propertyLeadPropery.displayLabel = propertyLeadPropery.displayLabel + " " + propertyLeadPropery.subjAdrPostalCode;
		}
		if(propertyLeadPropery.displayLabel == "") {
			propertyLeadPropery.displayLabel = "NA";
		}
		return propertyLeadPropery;
	}

  changePropertyLeadProfile(propertyLeadProfile: any){
		if (this.propertyLeadProperties.length > 0) {
			this.propertyLeadProperties.forEach(propertyLeadPropery => {
				if (propertyLeadPropery.propertyLeadProfileId == propertyLeadProfile.value) {
					this.selectedPropertyLeadProfile = propertyLeadPropery;
				}
			});
		}
	}

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.ownerLeadProfileService.addOwnerPropertyDetails(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doAdd.emit(this.ownerPropertyDetails);
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("msg: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.ownerLeadProfileService.updateOwnerPropertyDetails(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.doUpdate.emit(res.data.ownerProfile);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerPropertyDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

  formDelete() {
		try {
			this.ownerLeadProfileService.deleteOwnerPropertyDetails(this.form1.value.propertyLeadProfileId, this.form1.value.ownerLeadProfileId)
				.subscribe(
					(res: any) => {
						console.log('proformaIncome-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.form1.value.propertyLeadProfileId);
					},
					(err: any) => {
						console.log('proformaIncome-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

  formBuild() {
    this.form1 = this.formBuilder.group({
      opsNotes: ['', Validators.required],
      status: ['', Validators.required],
      propertyLeadProfileId: ['', Validators.required],
      ownerLeadProfileId: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.ownerPropertyDetails.createDate = moment(this.ownerPropertyDetails.createDate).toDate();
    this.ownerPropertyDetails.lastUpdate = moment(this.ownerPropertyDetails.lastUpdate).toDate();
  }
}
